module.exports = __webpack_public_path__ + "static/media/processing-payment-color.b2e22da1.png";